import React, { Fragment, useRef, useState, useEffect } from 'react';
import { render } from 'react-dom';
import { getCategories, list } from './apiCore';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import algoliasearch from 'algoliasearch';
import {
    InstantSearch,
    Hits,
    SearchBox,
} from 'react-instantsearch-dom';

const appId = 'O616IHS8SQ';
const apiKey = '1a61d9059fcc3f918576c7aa95279846';
const searchClient = algoliasearch(appId, apiKey);



const Search = () => { //must pass hits to parent
	const searchSubmit = e => {
        e.preventDefault()
	}; 
	const Hit = hit => (
        <div>
            <p> {JSON.stringify(hit)} </p>
        </div>
    );
    return (
        <div id='ais-InstantSearch'>
            <InstantSearch 
                indexName='dev_lootswap' 
                searchClient={searchClient}>
                <SearchBox/>
                <Hits hitComponent={Hit}/>
            </InstantSearch>
        </div>
    );
};

export default Search;
